import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";


const baseUrl = process.env.REACT_APP_BASE_URL;


export const getPaymentInstrumentIssuers = createAsyncThunk(
  "paymentInstrumentIssuers/getPaymentInstrumentIssuers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/platform/payment-instrument-issuers`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch payment instrument issuers"
      );
    }
  }
);

const initialState = {
  issuers: [],
  issuersLoading: false,
  issuersError: "",
};

const paymentInstrumentIssuersSlice = createSlice({
  name: "paymentInstrumentIssuers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentInstrumentIssuers.pending, (state) => {
        state.issuersLoading = true;
        state.issuersError = "";
      })
      .addCase(getPaymentInstrumentIssuers.fulfilled, (state, action) => {
        state.issuersLoading = false;
        state.issuers = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(getPaymentInstrumentIssuers.rejected, (state, action) => {
        state.issuersLoading = false;
        state.issuers = [];
        state.issuersError = action.payload || "Unexpected error";
      });
  },
});

export const selectIssuerTitleByCode = (code) => (state) =>
  state.paymentInstrumentIssuers.issuers.find((issuer) => issuer?.code === code)?.title;

export default paymentInstrumentIssuersSlice.reducer;
